import { createMapper, Module } from 'vuex-smart-module';

import ActionsGetters from './getters';
import ActionsState from './state';
import ActionsMutations from './mutations';
import ActionsActions from './actions';

const module = new Module({
  getters: ActionsGetters,
  namespaced: true,
  state: ActionsState,
  mutations: ActionsMutations,
  actions: ActionsActions,
});

export default module;

export const actionsStoreMapper = createMapper(module);
